import React from 'react'
import SubmitterExpenseReports from 'src/app/SubmitterExpenseReports/SubmitterExpenseReports'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesYourReportsRouteProps } from 'src/navigation/routeProps'

const ExpensesYourReportsAppRoute: AppRoute = {
  routeProps: expensesYourReportsRouteProps,
  component: <SubmitterExpenseReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesYourReportsAppRoute
